import { Easy69_v1 } from "../frfr-easy69-utils";
import { _zzyourmap_LAYER_TITLE_ALWAYSSHOW } from "./zz-yourmap-data-keys-and-values-lib";
import { _zzyourmap_extract_smestaj_map_marker_item_props } from "./zz-yourmap-map-utils";


// ----- admin panel frontend utils


// TODO
export const _zzyourmap_extract_admin_options = (destination_entities) => {
  // let slug_to_id_lookup_obj = {};
  let options_adm_parent_of_destination = [];
  let options_adm_parent_of_smestaj = [];
  if (Array.isArray(destination_entities)) {
    // console.log('entities', entities);
    destination_entities.forEach((item, index) => {
      if (item.vr_tablename === 'ym_table_destination') {
        if (item._master_flag_deleted === true) {
          // skip
        } else {
        }
        //
        if (item.of_id > 0 && item.destinacija_tip === "DESTINATION") {
          const destination_id = item.of_id;
          const destinacija_slug = item.destinacija_slug;
          const destinacija_naslov = item.destinacija_naslov;
          // if (js_utils.is_string_not_empty(item.destinacija_slug) && item.destinacija_tip === "DESTINATION") {
          // const destinacija_slug = item.destinacija_slug;
          const option_title = destinacija_naslov;
          // slug_to_id_lookup_obj[destinacija_slug] = destination_id;
          options_adm_parent_of_destination.push({ "title": option_title, "value": destination_id });
          // }
          //
          if (Array.isArray(item._subdestinations)) {
            item._subdestinations.forEach((sd) => {
              console.log('sd.of_id', sd.of_id);
              console.log('sd', sd);
              ////
              if (sd.of_id > 0) {
                // const destination_id = item.of_id;
                // const destinacija_slug = item.destinacija_slug;
                // slug_to_id_lookup_obj[destinacija_slug] = destination_id;
                // options_adm_parent_of_destination.push({ "title": destinacija_slug, "value": destination_id });
                // let option_title = destinacija_slug;
                let option_title = destinacija_naslov;
                let option_value;
                if (sd._is_subdestionation === true) {
                  if (sd._is_main_subdestionation === true) {
                    // option_title += ' (' + sd.destinacija_poddestinacija_naslov + ')';
                    option_title += ' (' + 'GLAVNA' + ')';
                    option_value = destination_id;
                  } else {
                    option_title += ' > ' + sd.destinacija_poddestinacija_naslov + '';
                    const subdestination_id = sd.of_id;
                    option_value = subdestination_id;
                  }
                  console.log('option_title', option_title);
                  options_adm_parent_of_smestaj.push({ "title": option_title, "value": option_value });
                }
              }
            });
          }
        }
        //
      }
    }); // end of foreach
  }
  return {
    options_adm_parent_of_destination,
    options_adm_parent_of_smestaj,
  };
};

